import { css } from "lit";

export const expandibleSwitchStyles = css`
  :host {
    display: block;
  }

  .expandible-content {
    interpolate-size: allow-keywords;
    transition:
      height 0.3s ease,
      display 0.3s allow-discrete;
    overflow: hidden;
  }

  @starting-style {
    .expandible-content {
      height: 0;
      opacity: 0;
    }
  }

  /* Form field styling for slotted content */
  .expandible-content ::slotted(.form-field) {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
  }

  .expandible-content ::slotted(.field-label) {
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-small);
    font-weight: var(--sds-typography-weight-medium);
    color: var(--sds-color-text-default-secondary);
  }
`;
